import $ from 'jquery';

export default class Hamburger {
  constructor() {
    this.$burgerButton = $('.hamburger');
    this.$mobileMenu = $('.mobile-header');
    this.addEvents();
  }

  addEvents() {
    this.$burgerButton.on('click', () => {
      this.$burgerButton.toggleClass('active');
      this.$mobileMenu.toggleClass('mobile-header--active');
    });
  }
}
